import { CSSProperties, FC, MouseEvent } from 'react';
import { Fab } from 'components/core/button';
import { ArrowLeft } from 'react-feather';
import { useLocation, useNavigate } from 'react-router-dom';

export const BackArrowButton: FC<{
  onClick?: (e: MouseEvent) => void;
  style?: CSSProperties;
}> = ({ onClick, style }) => {
  const back = useNavigate();
  const location = useLocation();
  const override = location?.state?.to;

  const handleBack = (e: MouseEvent) => {
    e.preventDefault();

    if (onClick) {
      onClick(e);
      return;
    }
    /**
     * Ideally, this should be back(override ?? -1)
     * but that confuses typescript as the useNavigate() method
     * is implemented as an overridden method (navigate(string) | navigate(number))
     * and will not accept navigate(string | number)
     */
    if (override) {
      back(override);
    } else {
      back(-1);
    }
  };

  return (
    <Fab
      className="-ml-3"
      aria-label="Back button"
      onClick={e => handleBack(e)}
      style={style}
    >
      <ArrowLeft />
    </Fab>
  );
};
